import React, { useState } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";

const ModelCard = ({ title, details, listeData }) => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const handleOffcanvasToggle = () => {
    setShowOffcanvas(!showOffcanvas);
    document.body.classList.toggle("offcanvas-open");
  };
  return (
    <>
      <Offcanvas
        isOpen={showOffcanvas}
        scrollable
        backdrop={false}
        toggle={handleOffcanvasToggle}
        style={{ width: "35%" }}
      >
        <OffcanvasHeader toggle={handleOffcanvasToggle}>
          Liste des balises
        </OffcanvasHeader>
        <OffcanvasBody>
          <div dangerouslySetInnerHTML={{ __html: listeData }} />
        </OffcanvasBody>
      </Offcanvas>
      <Card className="mb-4">
        <CardTitle tag="h5" style={{ paddingLeft: "10px" }}>
          {title}
        </CardTitle>
        <CardBody>
          {Object.entries(details).map(([key, value], index) => (
            <Row className="mb-3" key={index}>
              {key === "Liste des balises disponibles" ? (
                <>
                  <Col
                    xs={12}
                    md={12}
                    lg={4}
                    className="mb-3"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <i style={{ color: "#9d9c9c" }}>
                      <span style={{ display: "inline-block", width: "11em" }}>
                        {key} :
                      </span>
                    </i>
                  </Col>
                  <Col xs={12} md={12} lg={8} className="mb-2 col-md-8">
                    <span
                      style={{
                        paddingInlineStart: "4em",
                        whiteSpace: "balance",
                        display: "inline-block",
                        fontFamily: "sans-serif",
                      }}
                    >
                      <Button onClick={handleOffcanvasToggle}>Liste</Button>
                    </span>
                  </Col>
                </>
              ) : (
                <>
                  <Col
                    xs={12}
                    md={12}
                    lg={4}
                    className="mb-3"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <i style={{ color: "#9d9c9c" }}>
                      <span style={{ display: "inline-block", width: "11em" }}>
                        {key} :
                      </span>
                    </i>
                  </Col>
                  <Col xs={12} md={12} lg={8} className="mb-2 col-md-8">
                    <span
                      style={{
                        paddingInlineStart: "4em",
                        whiteSpace: "balance",
                        display: "inline-block",
                        fontFamily: "sans-serif",
                      }}
                    >
                      {typeof value === "object" &&
                      value !== null &&
                      value.label
                        ? value.label
                        : renderValue(value)}
                    </span>
                  </Col>
                </>
              )}
            </Row>
          ))}
        </CardBody>
      </Card>
    </>
  );
};

const renderValue = (value) => {
  if (value == null || (typeof value === "string" && value.trim() === "")) {
    return "";
  } else if (
    value === "Validé" ||
    value === "Validée" ||
    value === "Finalisée" ||
    value === "Dossier de souscription CGP" ||
    value === "Oui"
  ) {
    return (
      <span
        className="bg-success badge bg-secondary"
        style={{ fontSize: "100%" }}
      >
        {value}
      </span>
    );
  } else if (
    value === "En attente" ||
    value === "Commercialisation" ||
    value === "Optionnelle - à confirmer" ||
    value === "En cours"
  ) {
    return (
      <span className="bg-info badge bg-secondary" style={{ fontSize: "100%" }}>
        {value}
      </span>
    );
  } else if (
    value === "Ferme - en attente d'allocation" ||
    value === "Ferme - Rompu à rembourser" ||
    value === "Abandonnée" ||
    value === "Radiée" ||
    value === "Annulée" ||
    value === "Cloturée" ||
    value === "Non"
  ) {
    return (
      <span
        className="badge-soft-danger badge bg-secondary"
        style={{ fontSize: "100%" }}
      >
        {value}
      </span>
    );
  } else {
    return value;
  }
};

export default ModelCard;
